import React from 'react';
import Message from 'components/Message';
import { SvgSchedule } from 'components/Svgs';
import { intlMessage } from 'constants/propTypes';
import './YieldEmptyState.scss';

const YieldEmptyState = ({ title, subtitle }) => (
  <div className="yield-empty-state__container">
    <SvgSchedule className="mb+" />
    <Message as="p" message={title} />
    <Message as="p" message={subtitle} />
  </div>
);

YieldEmptyState.propTypes = {
  title: intlMessage.isRequired,
  subtitle: intlMessage.isRequired,
};

export default YieldEmptyState;
